@if (isFormDisabled() !== type.EDIT) {
  <cap-calendar
    styleClass="p-inputgroup"
    [minDate]="today"
    [formControl]="formControl | castTo: FormControl"
    [todayButtonStyleClass]="'hidden'"
    [clearButtonStyleClass]="'primary cap-button'">
  </cap-calendar>
} @else {
  <div class="disabled d-flex align-items-center">
    {{ formControl.value | date: 'dd-MM-yyyy' }}
  </div>
}
